import React, { Component } from 'react';
import { Icon } from '@trlogic/ui-pack';
import { BreachesResponse, WatchlistCustomerDomains } from '../../../domain/watchlist/WatchlistCustomerDomains';
import CustomLoading from '../../custom/CustomLoading';
import WatchlistDataNotFoundComponent from './WatchlistDataNotFoundComponent';
import LanguageUtil from '../../../util/LanguageUtil';

class WatchlistCustomerDataBreachesComponent extends Component<Props, State> {
  public state: State = new State();

  render() {
    const { response, customerLoading } = this.props;
    return (
      <div className={'w-full flex flex-col overflow-y-scroll h-auto bg-[#F9FAFB] rounded-md border-[1px] border-[#E0E4E8] rounded-xl'}>
        <div className={'border-b-[1px] border-[#E0E4E8] p-4'}>
          {LanguageUtil.get({ id: 'pages.alert.socialMedia.dataBreaches', defaultMessage: 'Data Breaches' })}
        </div>
        <div className={'grid grid-cols-1 overflow-y-scroll overflow-x-hidden h-[400px] bg-white'}>
          {customerLoading ? (
            <CustomLoading />
          ) : response == undefined ? (
            <WatchlistDataNotFoundComponent />
          ) : (
            response?.socialMedia.breaches.map((response, index) => {
              return (
                <div key={index} className='flex flex-col w-full rounded-xl'>
                  <div className={'flex items-center p-4 justify-between border-b'}>
                    <div className={'flex items-center'}>
                      <img alt='logo_typeface' style={{ width: 30, height: 30, fill: 'transparent', color: 'black' }} src={response.logoPath} />
                      <div className={'text-[#4F4F4F] text-[14px] font-normal px-[10px]'}>{response.name}</div>
                    </div>
                    <div className={`bg-[#DBFFEA] text-[#027A48] rounded-[500px] px-[8px] py-[2px] text-[10px] flex items-center gap-1`}>
                      {this.getIcon(response.accountType)}
                      {response.accountType}
                    </div>
                  </div>
                  <div className={'flex flex-col w-full p-0.5'}>
                    {Object.entries(this.getData(response)).map(([key, value], index) => (
                      <div key={index} className={'flex justify-between items-center border-b-[1px] border-[#E0E4E8] bg-white p-4'}>
                        <span className={'w-1/2'}>{key}</span>
                        <span className={'w-1/2 text-[12px] text-f-black-2 rounded-xl px-2'}>{value != undefined && value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    );
  }

  private getData = (response: BreachesResponse) => {
    return {
      Source: '-',
      Name: response.name || '-',
      Title: response.title || '-',
      Domain: response.domain || '-',
      'Breaches Date': response.breachDate || '-',
      'Added Date': response.addedDate || '-',
      'Modified Date': response.modifiedDate || '-',
      'Pwn Count': response.pwnCount || '-',
      'Data Classes': response.dataClasses || '-',
      'Description:': <div dangerouslySetInnerHTML={{ __html: response.description }} /> || '-',
    };
  };

  private getIcon = (type: string) => {
    if (type == 'EMAIL') {
      return <Icon icon={'found-mail'} size={13} color={'#027A48'} />;
    } else if (type == 'PHONE') {
      return <Icon icon={'found-phone'} size={13} color={'#027A48'} />;
    } else {
      return <Icon icon={'unknown'} size={13} color={'#4F4F4F'} />;
    }
  };
}

interface Props {
  response: WatchlistCustomerDomains | undefined;
  customerLoading: boolean;
}

class State {}

export default WatchlistCustomerDataBreachesComponent;
